import { useQuery } from '@tanstack/react-query';

import { ApiQueryKeys } from '@/interfaces/api/ApiQueryKeys';
import { haggleApiService } from '@/services/haggle.service';

export const useHasStoreProducts = (isQueryEnabled: boolean) => {
	const { data, isLoading, isFetching, refetch } = useQuery({
		queryKey: [ApiQueryKeys.hasStoreProducts],
		queryFn: () => haggleApiService.hasStoreProducts(),
		refetchOnWindowFocus: false,
		enabled: isQueryEnabled,
	});

	return {
		hasProducts: data?.hasProducts ?? false,
		isLoading,
		isFetching,
		refetch,
	};
};
